// extracted by mini-css-extract-plugin
export default {"subtitle":"LegendBox_subtitle__qvycF","wrapper_disabled":"LegendBox_wrapper_disabled__5K7Pt","card_disabled":"LegendBox_card_disabled__kL6Im","wrapper":"LegendBox_wrapper__4yedd"};